/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  currentContact: null,
  contactLoading: false,
  serverError: null,
  selectedSearchContacts: [],
};

export const actions = {
  async fetchContact({ commit, state }, { id }) {
    if (!state.currentContact || state.currentContact.crmId !== id) {
      commit('SET_LOADING', true);
      await api.get(`/contact/get/${id}`)
        .then((resp) => {
          commit('SET_CURRENT_CONTACT', resp.data);
          commit('SET_SERVER_ERROR', null);
        })
        .catch((error) => {
          commit('SET_SERVER_ERROR', error);
        })
        .finally(() => commit('SET_LOADING', false));
    }
  },
  setSelectedSearchContacts({ commit }, results) {
    commit('SET_SELECTED_SEARCH_CONTACTS', results);
  },
  addSelectedSearchContact({ commit }, id) {
    commit('ADD_SELECTED_SEARCH_CONTACT', id);
  },
  removeSelectedSearchContact({ commit }, id) {
    commit('REMOVE_SELECTED_SEARCH_CONTACT', id);
  },
};

export const mutations = {
  SET_SERVER_ERROR(state, serverError) {
    state.serverError = serverError;
  },
  SET_LOADING(state, loading) {
    state.contactLoading = loading;
  },
  SET_CURRENT_CONTACT(state, contact) {
    state.currentContact = contact;
  },
  ADD_SELECTED_SEARCH_CONTACT(state, contactId) {
    if (!state.selectedSearchContacts.includes(contactId)) {
      state.selectedSearchContacts.push(contactId);
    }
  },
  SET_SELECTED_SEARCH_CONTACTS(state, results) {
    state.selectedSearchContacts = results.map(x => x.crmId);
  },
  REMOVE_SELECTED_SEARCH_CONTACT(state, contactId) {
    const index = state.selectedSearchContacts.indexOf(contactId);
    if (index > -1) {
      state.selectedSearchContacts.splice(index, 1);
    }
  },
};
